export const siteMeta = {
  name: "蜜月TV",
  slogan: "蜜月TV官网入口 · 最新地址导航",
  updatedAt: "2026-10-11",
  statusText: "主线路运行正常",
  statusDetail: "本页线路均由人工核对整理，最近更新于 2026 年 10 月 11 日",
};

export const navItems = [
  { id: "quick-entry", label: "快速入口" },
  { id: "latest-address", label: "最新网址" },
  { id: "app-download", label: "APP下载" },
  { id: "access-guide", label: "访问教程" },
  { id: "content-zones", label: "内容分区" },
  { id: "device-support", label: "设备支持" },
  { id: "faq", label: "常见问题" },
  { id: "safety", label: "安全提示" },
];

export const heroStats = [
  { value: "4", label: "整理线路" },
  { value: "全平台", label: "手机 / 电脑 / 电视" },
  { value: "每周", label: "人工核对更新" },
];

export const quickEntries = [
  {
    id: "quick-main",
    icon: "ri-global-line",
    title: "官网主线路入口",
    desc: "优先使用的主访问线路，延迟低、解析稳定，适合日常直接打开。",
    actionLabel: "查看主线路名单",
    target: "#latest-address",
    tone: "primary",
  },
  {
    id: "quick-backup",
    icon: "ri-swap-box-line",
    title: "备用线路入口",
    desc: "当主线路出现波动时，可切换备用域名继续访问，不影响使用。",
    actionLabel: "查看备用线路",
    target: "#latest-address",
    tone: "accent",
  },
  {
    id: "quick-android",
    icon: "ri-android-line",
    title: "安卓 APP 下载",
    desc: "手机端安装包，安装后可获得更顺畅的播放与推送体验。",
    actionLabel: "前往下载",
    target: "#app-download",
    tone: "secondary",
  },
  {
    id: "quick-ios",
    icon: "ri-apple-fill",
    title: "iPhone / iPad 安装",
    desc: "通过官方描述文件方式安装，适用于 iOS 与 iPadOS 设备。",
    actionLabel: "前往下载",
    target: "#app-download",
    tone: "primary",
  },
  {
    id: "quick-tv",
    icon: "ri-tv-2-line",
    title: "TV 大屏版",
    desc: "智能电视与电视盒子安装包，配合遥控器操作，客厅观看更舒适。",
    actionLabel: "前往下载",
    target: "#app-download",
    tone: "secondary",
  },
  {
    id: "quick-cast",
    icon: "ri-cast-line",
    title: "投屏使用指南",
    desc: "不想安装？把手机画面投到电视同样可以观看，步骤见访问教程。",
    actionLabel: "查看教程",
    target: "#access-guide",
    tone: "accent",
  },
];

export const addressFilters = [
  { id: "all", label: "全部" },
  { id: "main", label: "主线路" },
  { id: "backup", label: "备用线路" },
  { id: "mobile", label: "移动优化" },
];

export const accessLines = [
  {
    id: "line-1",
    name: "主线 A",
    category: "main",
    categoryLabel: "主线路",
    url: "https://dfwgixu.cn",
    latency: "低延迟",
    latencyScore: 1,
    note: "首选线路，服务器资源充足，适合首次访问。",
    status: "推荐",
  },
  {
    id: "line-2",
    name: "主线 B",
    category: "main",
    categoryLabel: "主线路",
    url: "https://miyuetv-hall.com",
    latency: "低延迟",
    latencyScore: 1,
    note: "与主线 A 互为备份，登录状态通常互通。",
    status: "推荐",
  },
  {
    id: "line-3",
    name: "备用 1",
    category: "backup",
    categoryLabel: "备用线路",
    url: "https://miyue-tv.app",
    latency: "中等",
    latencyScore: 2,
    note: "主线路维护期间使用，页面结构保持一致。",
    status: "可用",
  },
  {
    id: "line-4",
    name: "备用 2",
    category: "backup",
    categoryLabel: "备用线路",
    url: "https://miyue.plus",
    latency: "中等",
    latencyScore: 2,
    note: "适合部分地区网络环境，遇到打不开时优先尝试。",
    status: "可用",
  },
  {
    id: "line-5",
    name: "移动优化线",
    category: "mobile",
    categoryLabel: "移动端优化",
    url: "https://m.miyuetv-mobile.com",
    latency: "低延迟",
    latencyScore: 1,
    note: "针对手机浏览器优化，流量占用更小，加载更快。",
    status: "推荐",
  },
  {
    id: "line-6",
    name: "海外线路",
    category: "backup",
    categoryLabel: "备用线路",
    url: "https://miyuetv-global.net",
    latency: "较高",
    latencyScore: 3,
    note: "面向海外网络环境的线路，延迟相对更高。",
    status: "可用",
  },
];

export const downloadItems = [
  {
    id: "dl-android",
    platform: "Android",
    icon: "ri-android-line",
    packageName: "Android APK 安装包",
    version: "v3.8.2",
    size: "42.6 MB",
    updated: "2026-10-08",
    requirement: "Android 7.0 及以上",
    desc: "手机端安装包，支持后台播放与消息推送，安装前请在系统设置中允许“未知来源应用”。",
  },
  {
    id: "dl-ios",
    platform: "iOS / iPadOS",
    icon: "ri-apple-fill",
    packageName: "iOS 描述文件安装",
    version: "v3.8.0",
    size: "68.4 MB",
    updated: "2026-10-05",
    requirement: "iOS 14.0 及以上",
    desc: "通过描述文件方式安装，安装后在“设置 - 通用 - VPN与设备管理”中信任即可使用。",
  },
  {
    id: "dl-tv",
    platform: "Android TV",
    icon: "ri-tv-2-line",
    packageName: "TV 大屏版",
    version: "v2.6.5",
    size: "35.1 MB",
    updated: "2026-09-28",
    requirement: "Android TV 8.0 及以上",
    desc: "适配遥控器操作与大屏布局，亦可安装于多数智能电视盒子。",
  },
  {
    id: "dl-hd",
    platform: "鸿蒙 / 通用",
    icon: "ri-smartphone-line",
    packageName: "鸿蒙通用版",
    version: "v3.7.9",
    size: "40.2 MB",
    updated: "2026-09-20",
    requirement: "HarmonyOS 2.0 及以上",
    desc: "面向鸿蒙设备优化的通用安装包，兼容大部分国产操作系统。",
  },
];

export const accessSteps = [
  {
    id: "step-1",
    title: "选择合适的线路",
    desc: "优先从“最新网址”中挑选标注为主线的地址，在浏览器地址栏完整输入并访问。",
    tip: "建议收藏 2 条以上线路，方便随时切换。",
  },
  {
    id: "step-2",
    title: "核对页面信息",
    desc: "进入后先确认页面名称与栏目是否与介绍一致，避免误入仿冒站点。",
    tip: "遇到强制下载未知插件、索要账号密码的页面请立即关闭。",
  },
  {
    id: "step-3",
    title: "安装 APP 或直接观看",
    desc: "网页端可直接浏览内容；如需更好体验，按“APP下载”章节对应系统安装客户端。",
    tip: "安装包下载完成后请核对文件大小与版本号。",
  },
  {
    id: "step-4",
    title: "投屏或切换设备",
    desc: "想在电视上观看，可用手机投屏，或直接安装 TV 大屏版配合遥控器操作。",
    tip: "投屏时确保手机与电视处于同一无线网络。",
  },
];

export const zoneTags = [
  { id: "all", label: "全部" },
  { id: "movie", label: "电影" },
  { id: "series", label: "电视剧" },
  { id: "variety", label: "综艺" },
  { id: "anime", label: "动漫" },
  { id: "doc", label: "纪录片" },
  { id: "sports", label: "体育赛事" },
];

export const zones = [
  {
    id: "z-movie",
    tag: "movie",
    tagLabel: "电影",
    icon: "ri-film-line",
    title: "电影专区",
    desc: "院线新片、经典老片与专题片单集中呈现，按类型与年份快速筛选。",
    points: ["动作 / 悬疑 / 爱情分栏", "高分片单定期整理", "支持清晰度切换"],
  },
  {
    id: "z-series",
    tag: "series",
    tagLabel: "电视剧",
    icon: "ri-clapperboard-line",
    title: "电视剧专区",
    desc: "国产剧、海外剧连续更新，可按更新节奏查看最新剧集进度。",
    points: ["追剧列表记录进度", "按热度与更新排序", "整季连续播放"],
  },
  {
    id: "z-variety",
    tag: "variety",
    tagLabel: "综艺",
    icon: "ri-mic-line",
    title: "综艺专区",
    desc: "真人秀、脱口秀与音乐类节目，按播出周期整期收录。",
    points: ["整期合集", "花絮与片段", "按节目名检索"],
  },
  {
    id: "z-anime",
    tag: "anime",
    tagLabel: "动漫",
    icon: "ri-magic-line",
    title: "动漫专区",
    desc: "新番与经典动画，提供按季度划分的更新索引。",
    points: ["季度新番表", "剧场版合集", "国语 / 原声可选"],
  },
  {
    id: "z-doc",
    tag: "doc",
    tagLabel: "纪录片",
    icon: "ri-earth-line",
    title: "纪录片专区",
    desc: "自然、人文与历史类纪录片，适合安静观看与学习参考。",
    points: ["人文历史", "自然地理", "科学探索"],
  },
  {
    id: "z-sports",
    tag: "sports",
    tagLabel: "体育赛事",
    icon: "ri-football-line",
    title: "体育专区",
    desc: "赛事集锦与录像回看，按项目与联赛归类，方便查找。",
    points: ["赛事集锦", "录像回看", "按联赛分类"],
  },
];

export const devices = [
  {
    id: "dev-mobile",
    icon: "ri-smartphone-line",
    name: "手机 / 平板",
    support: "完全支持",
    detail: "推荐使用移动优化线路或安装 APP，横竖屏均可浏览。",
    tone: "primary",
  },
  {
    id: "dev-pc",
    icon: "ri-computer-line",
    name: "Windows / macOS 电脑",
    support: "完全支持",
    detail: "直接通过浏览器访问，建议使用近两年更新的主流内核浏览器。",
    tone: "secondary",
  },
  {
    id: "dev-tv",
    icon: "ri-tv-2-line",
    name: "智能电视 / 电视盒子",
    support: "支持（安装 TV 版）",
    detail: "安装 TV 大屏版客户端，使用遥控器操作更顺手。",
    tone: "accent",
  },
  {
    id: "dev-cast",
    icon: "ri-cast-line",
    name: "投屏观看",
    support: "部分支持",
    detail: "手机与电视连接同一网络后即可投屏，实际体验取决于电视型号。",
    tone: "primary",
  },
];

export const faqs = [
  {
    id: "faq-1",
    q: "为什么有时候官网地址打不开？",
    a: "常见原因包括网络波动、线路临时维护或本地 DNS 缓存较旧。可先尝试刷新页面、更换浏览器，或切换到本页列出的备用线路；如仍无法访问，稍后再试通常即可恢复。",
  },
  {
    id: "faq-2",
    q: "找到了多个蜜月TV网址，如何判断哪个是官方入口？",
    a: "建议以本页整理的线路为准，并核对进入后的页面名称与栏目是否与介绍一致。官方入口不会要求你提供账号密码，也不会强制安装来源不明的插件，遇到这类页面请立即关闭。",
  },
  {
    id: "faq-3",
    q: "APP 安装时提示“无法安装”怎么办？",
    a: "多数情况是系统限制了外部来源安装。安卓设备可在“设置 - 安全”中允许未知来源应用后重试；iOS 设备需在“设置 - 通用 - VPN与设备管理”中信任对应描述文件。",
  },
  {
    id: "faq-4",
    q: "手机和电视可以共用同一个账号吗？",
    a: "通常情况下支持在多设备上使用同一账号，具体同时在线数量与规则以平台内的说明为准。为保障安全，不建议将账号借给他人使用。",
  },
  {
    id: "faq-5",
    q: "观看时卡顿或画面模糊怎么处理？",
    a: "先在播放界面切换清晰度，优先选择“自动”；其次检查本地网络是否稳定，可尝试切换 Wi-Fi 与移动数据，或改用延迟更低的线路。",
  },
  {
    id: "faq-6",
    q: "本页会存储平台内容吗？",
    a: "不会。本页仅整理访问指引与下载信息，不存放任何影视资源，也不提供上传或分享功能，所有内容均以播出方页面为准。",
  },
];

export const safetyTips = [
  {
    id: "safe-1",
    icon: "ri-shield-check-line",
    title: "认准官方渠道",
    desc: "只通过本页整理的线路与下载入口访问，遇到来源不明的二维码、群链接请勿点击。",
  },
  {
    id: "safe-2",
    icon: "ri-lock-line",
    title: "不泄露账号信息",
    desc: "正规页面不会索要你的支付密码、短信验证码，遇到此类请求应立即终止操作。",
  },
  {
    id: "safe-3",
    icon: "ri-alarm-warning-line",
    title: "警惕诱导下载",
    desc: "如页面强制弹出“必须安装插件才能播放”，大概率是仿冒站点，请关闭并改用其他线路。",
  },
  {
    id: "safe-4",
    icon: "ri-refresh-line",
    title: "定期更新客户端",
    desc: "保持 APP 为较新版本，可减少兼容性问题，也能获得更稳定的播放表现。",
  },
];

export const footerNav = [
  { id: "quick-entry", label: "快速入口" },
  { id: "latest-address", label: "最新网址" },
  { id: "app-download", label: "APP下载" },
  { id: "access-guide", label: "访问教程" },
  { id: "content-zones", label: "内容分区" },
  { id: "device-support", label: "设备支持" },
  { id: "faq", label: "常见问题" },
  { id: "safety", label: "安全提示" },
];